import { useContext } from 'react';
import { Url } from '@wix/da-url';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import type { MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import CoreMenuItem from '../../../_partials/CoreMenuItem';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
import userMenuStyles from '../UserMenuDesktop/UserMenuDesktop.scss';

export function useBuyCoreItem(): MenuItem & { key: string } {
  const { hasCoreMembership, coreLevel, coreExpires } =
    useContext(SessionContext);
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const isMobile = useContext(MobileContext);
  const linkUrl = Url.coreMembershipLink({ hasCoreMembership });

  return {
    key: 'buy-core',
    label: (
      <CoreMenuItem
        className={userMenuStyles['two-side-label']}
        hasCoreMembership={hasCoreMembership}
        coreLevel={coreLevel}
        coreExpires={coreExpires}
      />
    ),
    link: linkUrl,
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      link_url: linkUrl,
      menu_item: hasCoreMembership ? 'my_core' : 'core_membership',
      menu_name: 'profile',
    }),
    tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
  };
}
